import { AxDropdown } from "@axess/limestone";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxProgressBar, Step } from "../../Limestone/AxProgressBar/AxProgressBar";
import { AxLimeStone } from "../../Limestone/AxLimeStone";

@ModuleName("ServiceVoucherRedeem")
export class ServiceVoucherRedeem implements AxInit {
    private _i18nHelper = new I18nHelper();
    public ItemDropdown: AxDropdown = new AxDropdown();
    private _AxProgressBar = new AxProgressBar();
    private _AxLimestone = new AxLimeStone()
    private aliases = ['Wizzard', 'Quantity&Date', 'Summary'];
    private steps: Step[] = [
        {
            label: this._i18nHelper.GetTranslation(Translations.Voucher),
            type: 'inactive',
            alias: 'Wizzard',
        }, {
            label: this._i18nHelper.GetTranslation(Translations.QuantityDate),
            type: 'inactive',
            alias: 'Quantity&Date',
        }, {
            label: this._i18nHelper.GetTranslation(Translations.Summary),
            type: 'inactive',
            alias: 'Summary',
        }, {
            label: this._i18nHelper.GetTranslation(Translations.ShoppingCartCapitals),
            type: 'inactive',
            alias: 'Summary',
        }, {
            label: this._i18nHelper.GetTranslation(Translations.Checkout),
            type: 'inactive',
            alias: 'Summary',
        },
    ];


    private readonly voucherRegex = /^[A-Za-z0-9]{4}(-[A-Za-z0-9]{4}){3}$/;

    AxInit() {
        const $inputElement = $("#redeem-voucher-input-input");
        const $submitButton = $(".redeem-voucher-input-btn");
        const $infoButton = $("#info-link");

        this.setupEventListeners($inputElement, $submitButton, $infoButton);

        this.handleVoucherCodeFromQuery($inputElement, $submitButton);
        const alias = window.location.pathname.split(/\//).filter((sp) => this.aliases.includes(sp))?.pop() || 'Quantity&Date';
        const currentStepIndex = this.steps.findIndex((sp) => sp.alias === alias);
        this.steps.forEach((step: Step, index: number): void => {
            if (step.alias === alias) {
                step.type = 'active'
            } else if (step.alias !== alias && index < currentStepIndex) {
                step.type = 'done';
            } else {
                step.type = 'inactive';
            }
        });
        $('.ax-progressbar.header__progressbar').empty();
        this._AxProgressBar.Init({
            target: '.ax-progressbar.header__progressbar',
            steps: this.steps,
        });
    }

    private setupEventListeners($inputElement: JQuery<HTMLElement>, $submitButton: JQuery<HTMLElement>, $infoButton: JQuery<HTMLElement>): void {
        const $counter = $('[data-products-quantity]');

        // Handle Enter key on the input field
        $inputElement.on("keydown", (e: JQuery.KeyDownEvent) => {
            if (e.key === "Enter") {
                this._AxLimestone.LockButton($('.redeem-voucher-input-btn')?.get(0));
                e.preventDefault();
                this.redeemVoucher($inputElement);
            }
        });

        // Submit button click handler
        $submitButton.on("click", (e) => {
            this._AxLimestone.LockButton($('.redeem-voucher-input-btn')?.get(0));
            this.redeemVoucher($inputElement);
        });

        // Info button click handler
        $infoButton.on("click", () => {
            this.showCodeInformationModal();
        });

        // Handle Enter key to open the modal
        $infoButton.on("keydown", (event: JQuery.KeyDownEvent) => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.showCodeInformationModal();
            }
        });

        $('#submit-btn')
            .prop('disabled', $('#form-redeem-wizard').find('input[type=checkbox]:checked:not(:disabled)').length == 0)
            .on('click', (e) => {
                this._AxLimestone.LockButton(e.target);
                $(e.target).closest('form').trigger('submit');
            });

        $('input[name="select-all"]').on('change', (e) => {
            const $inputs = $('#form-redeem-wizard').find('input[type=checkbox]:not(:disabled)');
            const isAllChecked = $(e.currentTarget).is(':checked');
            $inputs.prop('checked', isAllChecked);
            $inputs.each((_, el: HTMLElement) => {
                $(el).closest('[data-product-item]')[isAllChecked
                    ? 'addClass'
                    : 'removeClass'
                ]('bg-light-orange');
            });
            $counter.text(isAllChecked ? $inputs.length : 0);
            $(e.currentTarget).closest('label')[isAllChecked
                ? 'removeClass'
                : 'addClass'
            ]('ax-checkbox--multi');
            $('#submit-btn').prop('disabled', !isAllChecked);
            this._AxLimestone.UnlockButton($('#submit-btn')?.get(0));
        });

        $('#form-redeem-wizard').on('change', (e) => {
            const isChecked = $(e.target).is(':checked');
            const $inputs = $(e.currentTarget).find('input[type=checkbox]:not(:disabled)');
            const $allChecked = $(e.currentTarget)
                .find('input[type=checkbox]:checked');
            $counter.text($allChecked.length);
                $(e.target).closest('[data-product-item]')[isChecked
                    ? 'addClass'
                    : 'removeClass'
                ]('bg-light-orange');
            $('input[name="select-all"]').prop('checked', $allChecked.length > 0);
            $('input[name="select-all"]').closest('label')[$allChecked.length > 0 && $allChecked.length < $inputs.length
                ? 'addClass'
                : 'removeClass'
            ]('ax-checkbox--multi');
            $('#submit-btn').prop('disabled', $allChecked.length === 0);
            this._AxLimestone.UnlockButton($('#submit-btn')?.get(0));
        });
    }

    private handleVoucherCodeFromQuery($inputElement: JQuery<HTMLElement>, $submitButton: JQuery<HTMLElement>): void {
        const urlParams = new URLSearchParams(window.location.search);
        const voucherCode = urlParams.get("voucherCode");

        if (voucherCode) {
            // Pre-fill the input field with the voucher code
            $inputElement.val(voucherCode);

            // Trigger the "Redeem Voucher" button click
            $submitButton.trigger("click");
        }
    }

    private redeemVoucher($inputElement: JQuery<HTMLElement>): void {
        const code = $inputElement.val()?.toString().trim();
        const $alertBanner = $(".redeem-voucher-alert");
        const $inputContainer = $inputElement.closest(".redeem-voucher-input-container");

        // Validate the input
        const validationError = this.validateVoucherError(code);
        if (validationError) {
            this.showErrorState($inputContainer, $alertBanner, validationError, $inputElement);
            return;
        }

        // Clear error state
        this.clearErrorState($inputContainer, $alertBanner);

        // Fetch voucher contents
        this.fetchVoucherContents(code!);
    }

    private validateVoucherError(code: string): string | undefined {
        let error: Translations | undefined;
        if (code === '') {
            error = Translations.SVCodeEmpty;
        }
        if (!this.voucherRegex.test(code)) {
            error = Translations.SVCodeInvalidSyntax;
        }
        return this._i18nHelper.GetTranslation(error);
    }

    private showErrorState(
        $inputContainer: JQuery<HTMLElement>,
        $alertBanner: JQuery<HTMLElement>,
        message: string,
        $inputElement: JQuery<HTMLElement>
    ): void {
        $inputContainer.addClass("error");
        $alertBanner.removeClass("d-none").text(message);

        // Add event listener to clear error state when typing starts
        $inputElement.on('keyup', this.debounce(() => {
            this.clearErrorState($inputContainer, $alertBanner);
            this._AxLimestone.UnlockButton($('.redeem-voucher-input-btn')?.get(0));
        }, 300) as EventListener);
    }

    private clearErrorState($inputContainer: JQuery, $alertBanner: JQuery): void {
        $inputContainer.removeClass("error");
        $alertBanner.addClass("d-none");
    }

    private debounce(fn: () => void, wait: number): () => void {
        let timeout: ReturnType<typeof setTimeout>;
        return (...args: any[]) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    private fetchVoucherContents(barcode: string): void {
        const actionUrl = "/ServiceVoucherRedeem/GetVoucherContents/";
        const requestData = { barcode };

        AxessViewer.loadPartialView(actionUrl, requestData, (response) => {
            if (response.success) {
                window.location.href = response.redirectUrl;
            } else {
                const $alertBanner = $(".redeem-voucher-alert");
                const $inputContainer = $("#redeem-voucher-input-input").closest(".redeem-voucher-input-container");
                this.showErrorState($inputContainer, $alertBanner, response.errMessage, $("#redeem-voucher-input-input"));
            }
        }, { type: "POST" });
    }

    private showCodeInformationModal(): void {
        const modalHtml = $('<div>', {
            id: 'voucher-info-modal',
            class: 'voucher-info-modal',
            role: 'dialog',
            'aria-labelledby': 'voucher-info-modal-title',
            'aria-describedby': 'voucher-info-modal-description',
            'tabindex': -1,
        }).append(
            $('<div>', { class: 'voucher-info-modal-content' }).append (
                $('<p>', { id: 'voucher-info-modal-description' }).text(
                    this._i18nHelper.GetTranslation(Translations.SVCodeAtWithThisFormat)
                )
            )
        );

        // Append modal to the body if it doesn't already exist
        if (!$("#voucher-info-modal").length) {
            $("body").append(modalHtml);

            // Close modal when clicking outside of it
            $(document).on("click", (event) => {
                if ($(event.target).is("#voucher-info-modal")) {
                    this.hideCodeInformationModal();
                }
            });

            // Close modal on Escape key press
            $(document).on("keydown", (event) => {
                if (event.key === "Escape") {
                    this.hideCodeInformationModal();
                }
            });
        }

        // Show the modal and focus it for accessibility
        $("#voucher-info-modal").fadeIn().focus();
    }

    private hideCodeInformationModal(): void {
        $("#voucher-info-modal").fadeOut(() => {
            $("#voucher-info-modal").remove(); // Remove modal from DOM after hiding
        });
    }
}